import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-tech bg-white" data-id="element-78" data-mp="9lv0spiridvb">
      <div className="h-1.5 bg-navy" aria-hidden="true" data-id="element-79" data-mp="4lqictyan92g" />
      <div className="h-1 bg-gold" aria-hidden="true" data-id="element-80" data-mp="4n1oh0f7oswq" />
      <div className="mx-auto max-w-5xl px-4 pb-5 pt-3 sm:px-6 sm:pb-7 sm:pt-5" data-id="element-81" data-mp="1297aw07qkt7q">
        <h1 className="mx-auto max-w-4xl text-center text-2xl leading-display text-navy sm:text-5xl" data-id="element-82" data-mp="1274l9hahx23j">
          MAÎTRISEZ L’ANATOMIE RADIOLOGIQUE,{' '}
          <span className="text-tech" data-id="element-83" data-mp="s9zypgcqn4m7">
            COMPRENEZ CHAQUE EXAMEN ET RECONNAISSEZ LES ANOMALIES
          </span>
        </h1>
        <p className="mx-auto mt-2 max-w-3xl rounded-lg bg-navy px-3 py-1.5 text-center font-display text-sm font-bold uppercase leading-tight text-white sm:text-lg" data-id="element-84" data-mp="neaz5d0pxnpw">
          UNE IMAGE À L’ÉCRAN…{' '}
          <span className="text-tech-light" data-id="element-85" data-mp="384s6ut3mwt56">MAIS SAVEZ-VOUS VRAIMENT QUOI REGARDER EN PREMIER ?</span>
        </p>

        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-steel sm:text-base" data-id="element-86" data-mp="3o7lvm11r3otp">
          Anatomie, radiographie, scanner, IRM, sémiologie, positionnement, radioprotection, cas
          pédagogiques et check-lists{' '}
          <strong className="font-semibold text-navy" data-id="element-87" data-mp="3e84mtar7cuti">
            réunis dans un système visuel structuré, pratique et prêt à consulter.
          </strong>
        </p>

        <MockupImage className="mt-2" priority data-id="element-88" data-mp="3599jq7jgg0uf" />

        <div className="mt-2 flex flex-col items-center" data-id="element-89" data-mp="35a2ial89fk1h">
          <CTAButton href={OFFER_ANCHOR} data-id="element-90" data-mp="2qkmt39odnmnw">🩻 OUI ! JE VEUX L’ATLAS COMPLET</CTAButton>
          <TrustLine items={['🛡️ Garantie satisfait ou remboursé de 7 jours', '🩻 Système complet 6 en 1']} data-id="element-91" data-mp="2vieuqvetqn5a" />
        </div>
      </div>
    </section>;
}